import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Baseproperties } from '../../utility/baseproperties'; 

@Injectable({
  providedIn: 'root'
})
export class EsignhomeService {
  constructor(private httpClient: HttpClient) { }
  baseproperties: Baseproperties = new Baseproperties();
  private baseURL = this.baseproperties.gatewayBaseURL;
  

  getESignById(esignid: String): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/esign/getesignbyid/${esignid}`);
  }
  getESignData(payload): Observable<any> {
    return this.httpClient.post(`${this.baseURL}/common/esign/getesigndata`, payload);
  }
  
  esignDataExcel() {
    return this.httpClient.get(`${this.baseURL}/common/esign/esignDataExcel`, { responseType: 'blob' });
  }

  getCSRFtoken(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/esign/getcsrf`);

  }
  getOrganisation(): Observable<any> {
    return this.httpClient.get(`${this.baseURL}/common/esign/getorganisations`);
  }
}
